import 'whatwg-fetch'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { detect } from 'detect-browser'
import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import App from '@/App.vue'
import routerConfig from '@/router'
import store from '@/store/index'
import initLocaleForage from '@/localforage'
import Localizer from '@/mixins/localizer'
import ApiHelper from '@/mixins/api-helper'
import CordovaDialogs from '@/mixins/cordova-diaglogs'
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import Router from 'vue-router'

Bugsnag.start({
  apiKey: '3bb19ba9160ce3c2bda16236a510f844',
  plugins: [new BugsnagPluginVue()],
})

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue)

Vue.mixin(Localizer)
Vue.mixin(ApiHelper)
Vue.mixin(CordovaDialogs)

Vue.use(Router)

// Vue config
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.silent = process.env.NODE_ENV === 'production';
// ----------------------

(async function () {
  const browser = detect()
  
  if (browser.name === 'samsung') {
    document.getElementById('app').style.setProperty('padding', '30px')
    document.getElementById('app')
      .textContent = 'Your web browser is not supported. Please use our store app or one of the following browsers "Google Chrome", "Mozilla Firefox", "Apple Safari" and "Microsoft Edge".'
    
    let link = document.createElement('a')
    link.style.setProperty('margin-top', '1em')
    link.href = 'https://play.google.com/store/apps/details?id=de.pixelstein.kabimobile'
    link.textContent = 'Google Play Store'
    document.getElementById('app').appendChild(link)
    
    let linkIos = document.createElement('a')
    linkIos.style.setProperty('margin-top', '1em')
    linkIos.href = 'https://apps.apple.com/de/app/hensel-recycling-katalog/id1341593032?l=en'
    linkIos.textContent = 'Apple App Store'
    document.getElementById('app').appendChild(linkIos)
    
    return
  }
  
  try {
    const forage = await initLocaleForage()
    Vue.prototype.$localforage = forage
    window.forage = forage
  } catch (e) {
    console.log('convert to IndexedDB failed', e)
  }
  
  const config = {}
  
  let defaultConfig = {}
  try {
    defaultConfig = await fetchConfigFile('./config/app-config.default.json')
  } catch (e) {
    console.error('default config file not found: ', e)
  }
  
  let localConfig = {}
  try {
    localConfig = await fetchConfigFile(
      ['./config/app-config', process.env.NODE_ENV, 'json'].join('.'))
  } catch (e) {
    console.error('local config file not found: ', e)
  }
  
  Object.assign(config, process.env, defaultConfig, localConfig)
  Object.seal(config)
  
  if (config.DISABLE_LOGGING) {
    console.log = () => null
    console.warn = () => null
  }
  
  window.Config = config
  Vue.prototype.$config = config
  
  const router = new Router(routerConfig)
  
  const apiBaseUrl = config.API_BASE_URL
  if (apiBaseUrl) {
    store.commit('setBaseUrl', apiBaseUrl) //@deprecated
    store.commit('Api/setApiBaseUrl', apiBaseUrl)
  }
  
  window.myApp = new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
  
  await defineCustomElements(window)
})()

function fetchConfigFile (file) {
  return process.env.NODE_ENV === 'development' ?
    fetch(file).then(response => response.json()).catch(err => console.log(err))
    : fetchLocalResource(file)
}

function fetchLocalResource (url) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest()
    req.onload = function () {
      const text = req.responseText
      resolve(JSON.parse(text))
      // Do something with text...
    }
    req.onerror = function () {
      reject('local fetch failed.')
    }
    req.open('GET', url)
    req.send()
  })
}

if (process.env.NODE_ENV === 'development') {
  console.log('development mode ✅')
  console.log('Vue.config', Vue.config)
}
